module.exports = __webpack_public_path__ + "img/BannerNewMobile.abf20fa8.svg";